module.exports = __webpack_public_path__ + "static/media/om_nose_button.23bd5278.png";